<i nz-icon [nzType]="icon"></i>